import React from 'react';
import Header from '../Controller/Header';
import UpdateForm from '../Controller/UpdateForm';
function Update() {
    return (
        <>
            <Header />
            <UpdateForm />
        </>
    );
}

export default Update;
